{
  "name": "@uppy/audio",
  "description": "Uppy plugin that records audio using the device’s microphone.",
  "version": "4.0.1",
  "license": "MIT",
  "style": "dist/style.min.css",
  "keywords": [
    "file uploader",
    "uppy",
    "uppy-plugin",
    "audio",
    "microphone",
    "sound",
    "record",
    "mediarecorder"
  ],
  "type": "module",
  "sideEffects": [
    "*.css"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "exports": {
    ".": "./lib/index.js",
    "./css/style.css": "./dist/style.css",
    "./css/style.min.css": "./dist/style.min.css",
    "./css/style.scss": "./src/style.scss",
    "./package.json": "./package.json"
  },
  "dependencies": {
    "preact": "^10.29.2"
  },
  "devDependencies": {
    "@uppy-dev/tsconfig": "workspace:^",
    "@vitest/browser-playwright": "^4.1.11",
    "cssnano": "^8.0.1",
    "playwright": "1.61.1",
    "postcss": "^8.5.23",
    "postcss-cli": "^11.0.1",
    "sass": "^1.89.2",
    "typescript": "^6.0.3",
    "vitest": "^4.1.11"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  },
  "publishConfig": {
    "access": "public"
  },
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "build:css": "sass --load-path=../../ src/style.scss dist/style.css && postcss dist/style.css -u cssnano -o dist/style.min.css",
    "typecheck": "tsc --build",
    "test": "vitest run --silent='passed-only'"
  }
}
